var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hit-vs-miss"},[_c('Doughnut',{attrs:{"values":_vm.missVsHitTargetData.values,"labels":_vm.missVsHitTargetData.labels,"colors":_vm.missVsHitTargetData.colors,"title":_vm.missVsHitTargetData.title,"semicircle":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }